import { render, staticRenderFns } from "./SubDealerView2.vue?vue&type=template&id=4aa75b82&scoped=true&lang=html&"
import script from "./SubDealerView2.vue?vue&type=script&lang=js&"
export * from "./SubDealerView2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa75b82",
  null
  
)

export default component.exports